export default __webpack_public_path__ + "static/media/SearchActive.1f068fb3.svg";